(
    function (skyward, $, undefined)
    {
        skyward.datepicker = skyward.datepicker || {};

        var _eventsBoundClassname = 'datepickerEventsBound';
        var _maxDatepickerHeight;
        var _revertToRelativeIfNoDateSelected = "revertToRelativeIfNoDateSelected";

        if (!$.datepicker)
        {
            skyward.error.reportException(new window.SkywardException("jquery ui datepicker script has not been initialized.", undefined, window.Severity.Error, "8C5A7AB5-8355-463C-9EBE-5AA373D7784A"));
        }

        // store datepicker's original functions for override
        var _baseGotoToday = $.datepicker._gotoToday;
        var _baseDoKeyDown = $.datepicker._doKeyDown;
        
        skyward.datepicker.setDatePicker = function (picker)
        {
            errorHelper.removeError(picker);
            
            var stringValue = picker.val();
            if (stringValue === "")
            {
                skyward.relativedatepicker.showDatePicker(picker.attr('id'));
                return;
            }

            if (!setDatepickerValue(picker, stringValue, false))
            {
                errorHelper.showError(picker);
            }

            skyward.relativedatepicker.showDatePicker(picker.attr('id'));
        };

        skyward.datepicker.destroy = function (picker)
        {
            picker.removeClass(_eventsBoundClassname);
            var dateIconSpan = picker.siblings(".datepicker-trigger");
            dateIconSpan.off();
            picker.off();
            picker.datepicker("destroy");
        };

        skyward.datepicker.registerDatepicker = function (picker)
        {
            picker = $(picker);
            if (picker.hasClass(_eventsBoundClassname))
            {
                return;
            }

            if (picker.is('[type=date]')) //currently only in mobile access
            {
                picker.on('change', function ()
                {
                    $(this).trigger("datePickerChangeComplete");
                });
                return;
            }
            
            setupDateIconSpan(picker);
            setDatepickerValue(picker, picker.val(), true);
            setDatepickerEvents(picker);
            setupModalControl(picker);
            setupVisibility(picker);

            picker.addClass(_eventsBoundClassname);
        };

        skyward.datepicker.getMaxDatepickerHeight = function (frameWindow = window)
        {
            if (_maxDatepickerHeight !== undefined)
            {
                return _maxDatepickerHeight;
            }
            // January 2000 spans six weeks, for the tallest possible datepicker
            _maxDatepickerHeight = getDatepickerHeight(new Date(2000, 0), frameWindow);
            return _maxDatepickerHeight;
        };

        skyward.datepicker.parseDateString = function (dateString)
        {
            return dateParsingHelper.parse(dateString);
        };

        skyward.datepicker.isValidDateObject = function (date)
        {
            return date instanceof Date && !isNaN(date); // Note: (new Date(null)) is a Valid Date
        };

        skyward.datepicker.show = function (picker, animate)
        {
            return toggleVisibility(picker, true, animate);
        };

        skyward.datepicker.hide = function (picker, animate)
        {
            return toggleVisibility(picker, false, animate);
        };

        function init()
        {
            this.find(".datepicker").each(function ()
            {
                skyward.datepicker.registerDatepicker(this);
            });
        }

        function setDatepickerValue(picker, value, clearOnInvalid)
        {
            // Remove potential trailing day string
            value = value.trim().split(" ", 1)[0];

            var dateValue = dateParsingHelper.parse(value);
            if (dateValue !== dateParsingHelper.getInvalidDate() && skyward.validation.validDate(dateValue))
            {
                internalSet(picker, dateValue);
                return true;
            }

            dateValue = skyward.time.parseDate(value);
            if (skyward.validation.validDate(dateValue))
            {
                internalSet(picker, dateValue);
                return true;
            }

            if (clearOnInvalid && !picker.has("promptHash") && !picker.has('environmentVariableBinding'))
            {
                skyward.controls.setValue(picker, "");
            }

            return false;

            function internalSet(pickerToSet, valueToSet)
            {
                picker.data(_revertToRelativeIfNoDateSelected, false);
                skyward.controls.setValue(pickerToSet, valueToSet, true);
            }
        }

        function setupDateIconSpan(picker)
        {
            var dateIconSpan = picker.siblings(".datepicker-trigger");

            if (dateIconSpan.length <= 0)
            {
                dateIconSpan = $('<span class="datepicker-trigger" id="' + picker.attr("id") + '-icon"/>');

                if (picker.is('[readonly]') || picker.is('[disabled]'))
                {
                    dateIconSpan.hide();
                }

                picker.wrap("<span class='datepicker-wrapper'></span>");
                picker.after(dateIconSpan);

                var svg = skyward.svg.getSvg('Date');
                var iconClass = picker.attr("data-datepicker-icon-class");
                if (iconClass)
                {
                    svg.addClass(iconClass);
                }

                dateIconSpan.append(svg);
            }

            dateIconSpan.on('click', function () { showDatepicker(picker); });
        }

        function setDatepickerEvents(picker)
        {
            picker.on("keypress", handleNewChar);
            picker.on("keyup", checkForDateHotkeys);
            picker.on("change", setDatePicker);
            picker.on("click", onClick);

            // We cancel normal input, so we have to trigger our own change
            setCustomChangeEvent(picker);
            
            if (picker.hasClass("birthDate"))
            {
                picker.on("change", updateBirthDateTextBox);
            }

            function checkForDateHotkeys(keyboardEvent)
            {
                var eventKeys = skyward.keys.getKeyNamesFromEvent(keyboardEvent);

                // Show the datepicker if it's not showing and tabbed into
                if (eventKeys.TAB && !picker.datepicker("widget").is(":visible"))
                {
                    picker.datepicker('show');
                }
                // Handle shortcut keys (T = Today, R = Tomorrow, Y = Yesterday)
                else if (eventKeys.T || eventKeys.R || eventKeys.Y)
                {
                    var shortcutDate = skyward.time.now();
                    if (eventKeys.R)
                    {
                        shortcutDate.setDate(shortcutDate.getDate() + 1);
                    }
                    else if (eventKeys.Y)
                    {
                        shortcutDate.setDate(shortcutDate.getDate() - 1);
                    }

                    const newDate = (shortcutDate.getMonth() + 1).toString().padLeft(2, '0') + '/' + shortcutDate.getDate().toString().padLeft(2, '0') + '/' + shortcutDate.getFullYear();
                    skyward.controls.setValue(picker, newDate);
                }
            }

            function handleNewChar(keyboardEvent)
            {
                var key = skyward.keys.getKeyFromEvent(keyboardEvent);
                var invalidCharsRegex = dateParsingHelper.getInvalidCharsRegex();

                // Handle unsupported keys
                if (!key || !key.value || invalidCharsRegex.test(key.value))
                {
                    return; // We allow default event handling
                }

                var value = picker.val();
                var coercedValue = replaceSelectionWithChar(value, key.value, keyboardEvent.target.selectionStart, keyboardEvent.target.selectionEnd);

                // Store cursor position, Set coerced value, Keep cursor position
                var cursorPosition = keyboardEvent.target.selectionStart + (value === coercedValue ? 0 : 1);
                picker.val(coercedValue);
                picker[0].setSelectionRange(cursorPosition, cursorPosition);

                // Stop the normal input from happening
                keyboardEvent.preventDefault();
            }

            function setCustomChangeEvent(picker)
            {
                let focusInValue;
                let focusInError = false;
                let isFocused = false;

                picker.on("focusin", onFocusin);
                picker.on("focusout", onFocusout);

                function onFocusin(focusEvent)
                {
                    // calling picker.val(coercedValue) in handleNewChart above will re focus the picker if the value is a complete formatted date, 
                    // causing the check in onFocusout to fail
                    if (isFocused)
                    {
                        return;
                    }

                    isFocused = true;
                    focusInValue = picker.val();
                    focusInError = errorHelper.hasError(picker);
                    errorHelper.toggleError(picker, false);
                }

                function onFocusout(focusEvent)
                {
                    isFocused = false;
                    if (focusInValue !== picker.val())
                    {
                        picker.trigger("change");
                    }
                    else
                    {
                        errorHelper.toggleError(picker, focusInError);
                    }
                }
            }
            
            function onClick(mouseEvent)
            {
                errorHelper.removeError(picker);
                picker.datepicker('show');
                selectDelimitedDatePart(mouseEvent);
            }

            function setDatePicker()
            {
                skyward.datepicker.setDatePicker(picker);
                picker.trigger("datePickerChangeComplete");
            }

            function updateBirthDateTextBox()
            {
                if (skyward.global.mobileAccess) //not supported in Mobile Access at the moment
                {
                    return;
                }

                var dob = skyward.controls.getValue(picker);
                var ageTextBox = picker.closest('.datepicker-wrapper').siblings().find(".birthDateAge");

                if (ageTextBox && dob)
                {
                    if (dob.isValidDate() && skyward.time.now().isValidDate())
                    {
                        var birthDate = new Date(dob);
                        var today = skyward.time.now();

                        var age = (today.getFullYear() - birthDate.getFullYear());

                        birthDate.setFullYear(birthDate.getFullYear() + age);
                        if (birthDate > today)
                        {
                            age--;
                        }

                        ageTextBox.val(age);
                    }
                    else
                    {
                        ageTextBox.val('');
                    }
                }
            }

            function replaceSelectionWithChar(currentValue, char, selectionStart, selectionEnd)
            {
                // Handle unsupported keys
                if (!char || dateParsingHelper.getInvalidCharsRegex().test(char))
                {
                    return currentValue;
                }

                // Handle the new character
                var newValue = currentValue.slice(0, selectionStart) + char + currentValue.slice(selectionEnd);

                // Remove potential trailing day string
                var dayStartIndex = newValue.search(dateParsingHelper.getInvalidCharsRegex());
                if (dayStartIndex !== -1 && dayStartIndex > 0)
                {
                    // The day is preceded by a space
                    newValue = newValue.substring(0, dayStartIndex - 1);
                }

                // The only character cannot be a delimiter
                if (newValue.length === 1 && dateParsingHelper.getDelimitersRegex().test(newValue))
                {
                    return currentValue;
                }

                // Dates cannot have more than 10 characters
                if (newValue.length > 10)
                {
                    return currentValue;
                }

                // Dates cannot have more than 8 digits
                var numDigits = newValue.replace(/[^0-9]/g, "").length;
                if (numDigits > 8)
                {
                    return currentValue;
                }

                // Dates cannot have more than 2 delimiters
                var delimiters = newValue.match(dateParsingHelper.getDelimitersRegex());
                if (delimiters && delimiters.length > 2)
                {
                    return currentValue;
                }

                // Delimiters should not touch
                var delimiterOneIndex = newValue.search(dateParsingHelper.getDelimitersRegex());
                var delimiterTwoIndex = delimiterOneIndex + newValue.substring(delimiterOneIndex + 1).search(dateParsingHelper.getDelimitersRegex()) + 1;
                if (delimiterOneIndex == delimiterTwoIndex + 1)
                {
                    return currentValue;
                }

                // Replace delimiters
                newValue = newValue.replace(dateParsingHelper.getDelimitersRegex(), '/');

                return newValue;
            }

            function selectDelimitedDatePart(mouseEvent)
            {
                // Ignore multiple character selections
                if (mouseEvent.target.selectionStart !== mouseEvent.target.selectionEnd)
                {
                    return;
                }

                var value = picker.val();

                // Remove potential trailing day string
                value = value.split(" ")[0];

                // Ignore invalid full-date formats
                var delimiters = value.match(dateParsingHelper.getDelimitersRegex());
                if (!delimiters || delimiters.length !== 2)
                {
                    return;
                }

                var delimiterOneIndex = value.search(dateParsingHelper.getDelimitersRegex());
                var delimiterTwoIndex = delimiterOneIndex + value.substring(delimiterOneIndex + 1).search(dateParsingHelper.getDelimitersRegex()) + 1;

                // Select the date portion clicked in
                var cursorPosition = mouseEvent.target.selectionStart;
                if (cursorPosition <= delimiterOneIndex)
                {
                    mouseEvent.target.selectionStart = 0;
                    mouseEvent.target.selectionEnd = delimiterOneIndex;
                }
                else if (cursorPosition > delimiterOneIndex && cursorPosition <= delimiterTwoIndex)
                {
                    mouseEvent.target.selectionStart = delimiterOneIndex + 1;
                    mouseEvent.target.selectionEnd = delimiterTwoIndex;
                }
                else
                {
                    mouseEvent.target.selectionStart = delimiterTwoIndex + 1;
                    mouseEvent.target.selectionEnd = value.length;
                }
            }
        }

        function setupModalControl(picker)
        {
            var modalLayer;

            picker.datepicker(
            {
                duration: 0,  // don't animate showing/hiding the picker. moving from one picker to another quickly will cause the second picker not to show
                defaultDate: skyward.time.now(), // ensure time traveling is honored
                onSelect: function ()
                {
                    $(this).change().focus();
                },
                beforeShow: function ()
                {
                    var control = $(this);

                    if (control.hasClass('relativeDate'))
                    {
                        control.data(_revertToRelativeIfNoDateSelected, true);
                        skyward.relativedatepicker.showDatePicker(this.id);
                    }

                    var datepickerPopup = $.datepicker.dpDiv;
                    setDatePickerPositioning(control, datepickerPopup);

                    skyward.window.registerLayoutResizeCallback(function ()
                    {
                        setDatePickerPositioning(control, datepickerPopup);
                    });

                    modalLayer = skyward.modalLayer.newModalLayer(datepickerPopup, function ()
                    {
                        datepickerPopup.appendTo(document.body);
                        control.datepicker("hide");
                    },
                    {
                        closeOnEscape: true,
                        expose: [control]
                    });
                           
                    return true;
                },
                onClose: function ()
                {
                    var control = $(this);
                    skyward.window.removeLayoutResizeCallback(setDatePickerPositioning);

                    if (control.data(_revertToRelativeIfNoDateSelected))
                    {
                        control.data(_revertToRelativeIfNoDateSelected, false);
                        skyward.relativedatepicker.showRelativeDateDisplay(this.id, control.attr('data-relative-date'));
                    }
                    if (!modalLayer.closing)
                    {
                        modalLayer.close();
                    }
                    
                },
                disabled: picker.attr('readonly')
            });
        }

        function setupVisibility(picker)
        {
            // When an absolute datepicker is intended to be hidden, the <input> element has the class "hidden", but the
            // wrapper we created in setupDateIconSpan() is still visible. We want to transfer the hidden-ness to the
            // wrapper, so the entire datepicker is hidden, and the <input> isn't hidden separately.
            // Relative datepickers come from the server already wrapped, and with the hidden class already applied to
            // their wrapper, so they don't have to do anything.
            if (picker.hasClass("hidden") && !picker.hasClass("hasRelativeDatePicker"))
            {
                picker.closest(".datepicker-wrapper").hide();
                picker.removeClass("hidden");
            }
        }

        var setDatePickerPositioning = function (control, datePickerPopup)
        {
            var offset = control.offset();
            var spaceAbove = offset.top;
            var spaceBelow = window.innerHeight - offset.top;

            var padding = 3;
            var top = spaceAbove > spaceBelow ? (spaceAbove - skyward.datepicker.getMaxDatepickerHeight() - padding) : spaceAbove + control.outerHeight() + padding;
            if (top < 0)
            {
                top = 0;
            }
            else if (top + skyward.datepicker.getMaxDatepickerHeight() > window.innerHeight)
            {
                top = window.innerHeight - skyward.datepicker.getMaxDatepickerHeight();
            }

            datePickerPopup.css(
                {
                    top: top,
                    left: offset.left,
                    position: 'absolute'
                });
        };

        function showDatepicker(picker)
        {
            picker.datepicker("show");
        }

        function getDatepickerHeight(date, frameWindow)
        {
            // Calling setDate() is necessary to get the height of the currently selected month (if you selected a month
            // with a different number of weeks, then opened the datepicker again, it would still have the old height).
            // Using a separate datepicker is necessary to keep setDate() from triggering unwanted change events.
            var body = $(frameWindow.document.body);
            var control = $('<input>');
            control.datepicker();
            control.datepicker('setDate', date);
            control.datepicker('refresh');
            var scrollContainer = $("<div style='height: 0; width: 0; position: absolute; overflow: hidden;'>", frameWindow);
            var widget = control.datepicker('widget');
            scrollContainer.append(widget);
            body.append(scrollContainer);
            var height = widget.outerHeight(true);
            body.append(widget);
            control.datepicker('destroy');
            scrollContainer.remove();
            return height;
        }

        /**
         * Override datepicker "today" button so that it both highlights *and* selects the date.
         * 
         * @param {any} id
         */
        function goToTodayDayOverride(id)
        {
            _baseGotoToday?.call(this, id);

            var target = $(id);
            var inst = this._getInst(target[0]);
            var now = skyward.time.now();
            this._selectDate(id, this._formatDate(inst, now.getDate(), now.getMonth(), now.getFullYear()));
        }

        function doKeyDownOverride(keyboardEvent)
        {
            var eventKeys = skyward.keys.getKeyNamesFromEvent(keyboardEvent);

            // Override datepicker keydown to prefer our date parsing on enter
            if (eventKeys.ENTER) // Copy how jquery-ui handles keys rather than skyward.ui.keys.js
            {
                var target = $(keyboardEvent.target);
                var date = dateParsingHelper.parse(target.val());

                if (date !== dateParsingHelper.getInvalidDate())
                {
                    target.datepicker("setDate", date);
                }
            }
            _baseDoKeyDown(keyboardEvent);
        }

        function toggleVisibility(picker, visibility, animate)
        {
            var outermostSelector = picker.hasClass("hasRelativeDatePicker") ? ".relativeDate__positioning" : ".datepicker-wrapper";
            var parentElem = picker.closest(outermostSelector);

            if (animate !== false)
            {
                parentElem.animateToggle(visibility);
            }
            else
            {
                parentElem.toggle(visibility);
            }
            return parentElem;
        }

        var dateParsingHelper = (function ()
        {
            var _invalidDate = new Date(NaN);

            var dateParsingHelper = {};

            dateParsingHelper.getInvalidDate = function ()
            {
                return _invalidDate;
            };

            dateParsingHelper.getInvalidCharsRegex = function ()
            {
                return /[^0-9.\/\\\- ]/g;
            };

            dateParsingHelper.getDelimitersRegex = function ()
            {
                return /[.\/\\\- ]/g;
            };

            dateParsingHelper.parse = function (value)
            {
                if (!value || typeof value !== "string")
                {
                    return _invalidDate;
                }

                value = value.trim();
                value = value.substring(0, 10);
                value = value.replace(dateParsingHelper.getInvalidCharsRegex(), '');

                var valueHasDelimiters = dateParsingHelper.getDelimitersRegex().test(value);
                return valueHasDelimiters ? parseDateWithDelimiters(value) : parseDateWithoutDelimiters(value);
            };

            return dateParsingHelper;

            function parseDateWithDelimiters(value)
            {
                var month;
                var day;
                var year;

                value = value.split(dateParsingHelper.getDelimitersRegex());
                switch (value.length)
                {
                    case 3:
                        month = parseMonthString(value[0]);
                        day = parseDayString(value[1]);
                        year = parseYearString(value[2]);
                        break;

                    case 2:
                        month = parseMonthString(value[0]);
                        day = parseDayString(value[1]);
                        year = new Date().getFullYear();
                        break;

                    default:
                        return _invalidDate;
                }                

                if (month === _invalidDate || day === _invalidDate || year === _invalidDate)
                {
                    return _invalidDate;
                }

                if (!skyward.validation.validDate(month + '/' + day + '/' + year.toString().padLeft(4, "0")))
                {
                    return _invalidDate;
                }

                return skyward.time.newDate(year, month - 1, day);
            }

            function parseDateWithoutDelimiters(value)
            {
                var dayMonth;
                var year;

                switch (value.length)
                {
                    case 4:
                        dayMonth = parseDayMonthString(value.slice(0, 2));
                        year = parseYearString(value.slice(2, 4));
                        break;

                    case 5:
                        dayMonth = parseDayMonthString(value.slice(0, 3));
                        year = parseYearString(value.slice(3, 5));
                        break;

                    case 6:
                        dayMonth = parseDayMonthString(value.slice(0, 4));
                        year = parseYearString(value.slice(4, 6));
                        break;

                    case 7:
                        dayMonth = parseDayMonthString(value.slice(0, 3));
                        year = parseYearString(value.slice(3, 7));
                        break;

                    case 8:
                        dayMonth = parseDayMonthString(value.slice(0, 4));
                        year = parseYearString(value.slice(4, 8));
                        break;
                    default:
                        return _invalidDate;
                }

                if (dayMonth.day === _invalidDate || dayMonth.month === _invalidDate || year === _invalidDate)
                {
                    return _invalidDate;
                }

                if (!skyward.validation.validDate(dayMonth.month + '/' + dayMonth.day + '/' + year.toString().padLeft(4, "0")))
                {
                    return _invalidDate;
                }

                return skyward.time.newDate(year, dayMonth.month - 1, dayMonth.day);
            }

            function parseDayMonthString(value)
            {
                var month;
                var day;

                switch (value.length)
                {
                    case 2:
                        month = '0' + value.charAt(0);
                        day = '0' + value.charAt(1);
                        break;

                    case 3:
                        if (value.charAt(0) === '0' || value.charAt(1) === '0')
                        {
                            month = value.charAt(0) + value.charAt(1);
                            day = '0' + value.charAt(2); // They didn't have a leading 0 for the month, so they probably didn't want one for the day
                        }
                        else
                        {
                            month = '0' + value.charAt(0);
                            day = value.charAt(1) + value.charAt(2);
                        }
                        break;

                    case 4:
                        month = value.charAt(0) + value.charAt(1);
                        day = value.charAt(2) + value.charAt(3);
                        break;
                }

                var dayMonth =
                {
                    month: parseMonthString(month),
                    day: parseDayString(day)
                };

                return dayMonth;
            }

            function parseDayString(value)
            {
                value = parseInt(value);
                return !isNaN(value) ? value : _invalidDate;
            }

            function parseMonthString(value)
            {
                value = parseInt(value);
                return !isNaN(value) ? value : _invalidDate;
            }

            function parseYearString(value)
            {
                var year;

                switch (value.length)
                {
                    case 2:
                        var currentYear = new Date().getFullYear();
                        var currentCentury = parseInt(currentYear.toString().slice(0, -2), 10);

                        var proposedYear = parseInt(currentCentury + value);
                        var minYear = currentYear - 70;
                        var maxYear = currentYear + 30;

                        if (minYear < proposedYear && maxYear >= proposedYear)
                        {
                            year = proposedYear;
                        }
                        else
                        {
                            year = (currentCentury - 1).toString() + value;
                        }
                        break;

                    case 4:
                        year = value;
                        break;
                }

                year = parseInt(year);
                return !isNaN(year) ? year : _invalidDate;
            }
        })();

        var errorHelper = (function ()
        {
            var _errorClass = "js-error-control--preSaveValidation";
            var _errorLi = $("<li>", {
                addClass: ["error-text", "js-error-text--invalidDate"],
                append: $("<span>", {
                    append: [
                        skyward.svg.getSvg("Error", "Error").addClass(["alertError", "svgNoHover"]),
                        $("<span>", {
                            addClass: "validationSpan",
                            text: "This is not a valid date."
                        })
                    ]
                })
            });

            var errorHelper = {};

            errorHelper.showError = function (picker)
            {
                errorHelper.toggleError(picker, true);
            };

            errorHelper.removeError = function (picker)
            {
                errorHelper.toggleError(picker, false);
            };

            errorHelper.hasError = function (picker)
            {
                return picker.hasClass(_errorClass);
            };

            errorHelper.toggleError = function (picker, toggle)
            {
                let dataValidateMessageFor = $();
                let dataValidateTextFor = $();
                let searchRoot = $(".workflowContent");
                if (searchRoot.length === 0)
                {
                    searchRoot = $(document)
                }

                var key = picker.attr("id");
                if (key)
                {
                    // DatePickers' ids within DataObjectViewers have the DataObjectViewer's id prepended to them
                    // with an underscore, so remove the final underscore and anything preceding it.
                    var datePickerID = key.split('_');
                    datePickerID = datePickerID[datePickerID.length - 1];

                    dataValidateMessageFor = searchRoot.find('[data-validate-message-for="' + datePickerID + '"]');
                    dataValidateTextFor = searchRoot.find('[for="' + key + '"]');
                }

                if (dataValidateMessageFor.length === 0)
                {
                    key = picker.attr('data-validate-control-for')
                    dataValidateMessageFor = searchRoot.find('[data-validate-message-for="' + key + '"]');
                    dataValidateTextFor = searchRoot.find(`[data-validate-text-for="${key}"]`);
                }
                let hasOtherErrors = false;

                if (dataValidateMessageFor.length !== 0)
                {
                    const oldErrorMessage = dataValidateMessageFor.find(".js-error-text--invalidDate");
                    const hadError = oldErrorMessage.length > 0;
                    hasOtherErrors = dataValidateMessageFor.find(".error-text").not(oldErrorMessage).length > 0;

                    if (toggle != hadError)
                    {
                        if (toggle)
                        {
                            let ul = dataValidateMessageFor.find("ul.validation-list");
                            if (ul.length === 0)
                            {
                                ul = $("<ul>", { addClass: "validation-list" }).appendTo(dataValidateMessageFor);
                            }
                            _errorLi.clone().appendTo(ul);
                        }
                        else
                        {
                            oldErrorMessage.remove();
                            const ul = dataValidateMessageFor.find("ul.validation-list");
                            if (ul.children().length === 0)
                            {
                                ul.remove();
                            }
                        }
                        const cma = skyward.contentMessageArea.getContentMessageArea(picker.closest(".js-changeTrackingRoot").parent());
                        cma?.modifyValidationCount(toggle ? 1 : -1, 0);
                    }
                }

                picker.toggleClass(_errorClass, toggle);
                picker.toggleClass("error-control", toggle || hasOtherErrors);
                dataValidateTextFor.toggleClass("error-text", toggle || hasOtherErrors);
            };

            return errorHelper;
        })();

        $.datepicker._triggerClass += "datepicker-trigger";
        $.datepicker._gotoToday = goToTodayDayOverride;
        $.datepicker._doKeyDown = doKeyDownOverride;
        $.datepicker.setDefaults(
        {
            dateFormat: "mm/dd/yy",
            prevText: "←",
            nextText: "→",
            dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
            constrainInput: true,
            showOtherMonths: true,
            selectOtherMonths: true,
            showButtonPanel: true,
            changeYear: true,
            changeMonth: true,
            showOn: "button",
            showAnim: "fadeIn",
            yearRange: "c-100:c+10",
            minDate: skyward.time.newDate(1, 0, 1),
            maxDate: skyward.time.newDate(9999, 11, 31)
        });

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
